const screens = require( '../../../tailwind.config' ).screens;
const _docFontSize = getComputedStyle( document.documentElement ).fontSize || 16;
const BASE_FONT_SIZE = parseInt( _docFontSize, 10 );

export default {
    screenSmallest: 0,
    screenSmall: parseFloat( screens.sm, 10 ) * BASE_FONT_SIZE,
    screenMedium: parseFloat( screens.md, 10 ) * BASE_FONT_SIZE,
    screenLarge: parseFloat( screens.lg, 10 ) * BASE_FONT_SIZE,
    screenBase: parseFloat( screens.xl, 10 ) * BASE_FONT_SIZE
};